import React from "react";
import { ArrowLeft, MessageSquare } from "lucide-react";
import { Link } from "react-router-dom";

const contacts = [
  {
    id: 1,
    name: "Ashley emyy",
    avatar: "/a_1.png",
    lastMessage: "Hi, How are you",
    timestamp: "Sat, 1:00PM",
    unreadCount: 2,
    initials: "AE",
  },
  {
    id: 2,
    name: "Aditi",
    avatar: "/a_2.png",
    lastMessage: "Hi, How are you",
    timestamp: "Sat, 1:00PM",
    unreadCount: 2,
    initials: "AD",
  },
  {
    id: 3,
    name: "Vamika",
    avatar: "/a_3.png",
    lastMessage: "Hi, How are you",
    timestamp: "Sat, 1:00PM",
    unreadCount: 2,
    initials: "VA",
  },
  {
    id: 4,
    name: "Mehar",
    avatar: "/a_4.png",
    lastMessage: "Hi, How are you",
    timestamp: "Sat, 1:00PM",
    unreadCount: 2,
    initials: "ME",
  },
  {
    id: 5,
    name: "Shivanya",
    avatar: "/a_5.png",
    lastMessage: "Hi, How are you",
    timestamp: "Sat, 1:00PM",
    unreadCount: 2,
    initials: "SH",
  },
];

function MatriChatList() {
  return (
    <div className="max-w-5xl mx-auto px-4 py-8 min-h-screen space-y-12 -mb-10">
      {/* Back Link */}
      <Link
        to="#"
        className="flex items-center text-base text-black font-medium mt-4"
      >
        <ArrowLeft className="h-6 w-6 mr-2" />
        Chat List
      </Link>

      {/* Profile Picture & Name */}
      <div className="flex flex-col items-center">
        <div className="w-36 h-36 rounded-full overflow-hidden bg-pink-200 mb-2">
          <img
            src="m_header.jpg"
            alt="Profile"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex items-center gap-2">
          <button className="text-gray-600">
            <img src="/edit.png" className="h-5 w-5" alt="Edit" />
          </button>
          <h2 className="text-xl font-medium">Ashley emyy</h2>
        </div>
      </div>

      {/* Chat List */}
      <div className="w-full max-w-5xl mx-auto min-h-screen">
        <div>
          {contacts.map((contact) => (
            <div key={contact.id} className="border-b border-gray-300">
              <div className="flex items-center p-4 hover:bg-gray-200 cursor-pointer transition-colors">
                {/* Profile Avatar */}
                <div className="flex-shrink-0 mr-5">
                  <div className="w-16 h-16 rounded-full overflow-hidden bg-gradient-to-br from-purple-400 to-pink-400 text-white flex items-center justify-center font-medium text-sm">
                    {contact.avatar ? (
                      <img
                        src={contact.avatar}
                        alt={contact.name}
                        className="w-full h-full object-cover object-top"
                      />
                    ) : (
                      contact.initials
                    )}
                  </div>
                </div>

                {/* Contact Info */}
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1">
                    <h3 className="text-lg font-semibold text-gray-900 truncate">
                      {contact.name}
                    </h3>
                    <span className="text-sm text-green-600 font-medium">
                      {contact.timestamp}
                    </span>
                  </div>

                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-2 min-w-0 flex-1">
                      <MessageSquare className="w-4 h-4 text-green-600 flex-shrink-0" />
                      <p className="text-sm text-gray-600 truncate">
                        {contact.lastMessage}
                      </p>
                    </div>

                    <div className="flex items-left justify-end">
                      {contact.unreadCount > 0 && (
                        <div className="bg-green-500 hover:bg-green-600 text-white rounded-full min-w-[24px] h-6 flex items-center justify-center text-xs font-medium ml-2">
                          {contact.unreadCount}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default MatriChatList;
